import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const ParentListPage = () =>
  import('@modules/parent/components/parent-list-page.vue');
const ParentFormPage = () =>
  import('@modules/parent/components/parent-form-page.vue');
const ParentViewPage = () =>
  import('@modules/parent/components/parent-view-page.vue');
const ParentImporterPage = () =>
  import('@modules/parent/components/parent-importer-page.vue');

export default [
  {
    name: '',
    path: '',
    component: Layout,
    meta: { auth: true },
    children: [
      {
        props: true,
        name: 'parent',
        path: '/parent/:subpropertyid',
        component: ParentListPage,
        meta: {
          auth: true,
          permission: Permissions.values.parentView,
        },
      },
      {
        props: true,
        name: 'parentNew',
        path: '/parent/new/:subpropertyId',
        component: ParentFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.parentCreate,
        },
      },
      {
        props: true,
        name: 'parentImporter',
        path: '/parent/import/:subpropertyid',
        component: ParentImporterPage,
        meta: {
          auth: true,
          permission: Permissions.values.parentImport,
        },
      },
      {
        name: 'parentEdit',
        path: '/parent/:id/edit/:subpropertyid',
        component: ParentFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.parentEdit,
        },
        props: true,
      },
      {
        name: 'parentView',
        path: '/parent/:id/:subpropertyId',
        component: ParentViewPage,
        meta: {
          auth: true,
          permission: Permissions.values.parentView,
        },
        props: true,
      },
    ],
  },
];
